<template>
  <div>
    <Header/>
    <Scroll/>
    <div class="mall_mypageWrap">
      <div class="mall_flexWrap" v-if="statusData.cartListData.length !== 0">
        <div class="mallMy_wrap"> <!-- 왼쪽 리스트 mallMy_wrap mallMy_cartListBody-->
          <h2 class="mallMy_tit">장바구니</h2>
          <div class="mallMy_cartListWrap">
            <div
            class="mallMy_cartListInner"
            > <!-- pageCartlist_wrap -->
              <div class="mallMy_cL_titBox"> <!-- v-on:click="view_cart_list"  pageCartlist_titBox -->
                <label class="mallMy_cL_pdInfo_checkBox">
                  <input
                    type="checkbox"
                    :id="'checkbox_'+index"
                    :value="index"
                    v-on:click="all_check"
                  />
                  <span>전체 선택</span>
                </label>
                <button v-on:click="remove_selected_items">선택 삭제</button>
                <!-- <p>
                  <img
                    :src="statusData.viewStatus === true ? require(`@/assets/images/icon/arrow_up.png`) :  require(`@/assets/images/icon/arrow_down.png`)"
                    alt="화살표"/>
                </p> -->
              </div>
              <div> <!-- :class="statusData.viewStatus === true ? '' : 'display_none'" -->
                <div
                  v-for="(item, index) in statusData.cartListData"
                  :key="index"
                  class="mallMy_cartListBox"> <!-- 이게 이너임 -->
                  <div class="mallMy_cL_pdInfo">
                    <div class="mallMy_cL_pdInfo_pd"> <!-- 플렉스 왼쪽 -->
                      <label class="mallMy_cL_pdInfo_checkBox">
                        <input
                          type="checkbox"
                          :id="'checkbox_'+index"
                          :value="index"
                          v-model="statusData.selectList"
                        />
                        <span></span>
                      </label>
                      <p class="mallMy_cL_pdInfo_pdTit">{{item.product.product_kor_name}}</p> <!-- 제품명 -->
                      <div class="mall_pListBox_stateTag mgb10"> <!-- 태그 -->
                        <div class="mall_pListBox_stateTag_new" v-if="item.product.product_new === 1">New</div>
                        <div class="mall_pListBox_stateTag_inStock" v-if="item.product.product_in_stock === 1">재고보유</div>
                        <div class="mall_pListBox_stateTag_best" v-if="item.product.product_best === 1">Best</div>
                        <div class="mall_pListBox_stateTag_sale" v-if="item.product.product_sale === 1">Sale</div>
                        <div class="mall_pListBox_stateTag_expected" v-if="item.product.product_expected === 1">입고예정</div>
                        <div class="mall_pListBox_stateTag_soldOut" v-if="item.product.product_sold_out === 1">Sold out</div>
                        <div class="mall_pListBox_stateTag_event" v-if="item.product.product_event === 1">Event</div>
                      </div>

                      <p class="pageProductDatail_explainBox_productInfo"> <!-- 가격 -->
                        <template v-if="item.product.product_discount === 0">
                          {{ formatPrice(item.product.product_sale_price) }}원
                        </template>
                        <template v-else>
                          <div>
                            <p class="dc_origin">{{ formatPrice(item.product.product_sale_price)}}원</p>
                            <p class="dc_dcPrice">{{formatPrice(item.product.product_discount)}}원</p>
                          </div>
                        </template>
                      </p>

                      <div class="pageCartlist_dataOption" v-if="item.product_option.length"> <!-- 옵션 -->
                        <div v-if="item.cart_list.product_group_option_name">
                          <p>
                            [{{item.cart_list.product_group_option_title}}] :
                            {{item.cart_list.product_group_option_name}}
                          </p>
                        </div>
                        <div
                          v-for="(option_item, option_index) in item.product_option"
                          :key="option_index">
                          <p>
                            [옵션{{option_index+1}} :
                            {{option_item.product_option_name}}]
                            {{option_item.product_option_list_name}}
                            ({{String(option_item.product_option_list_plus_sale_price).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}원)
                          </p>
                        </div>
                        <p v-if="item.cart_list.product_note">
                          [{{item.cart_list.product_note_title}}] {{item.cart_list.product_note}}
                        </p>
                      </div>
                    </div>

                    <div class="mallMy_cL_pdInfo_img"> <!-- 플렉스 오른쪽 -->
                      <img
                        class="pageCartlist_dataMainImg"
                      :src="statusData.baseUrlExport + item.product.product_image">
                    </div>
                  </div>
                  <div class="pageProductDatail_explainBox_quantity">
                    <p>수량</p>
                    <div>
                      <button v-on:click="change_selling_count(index, -1)"></button>
                      <p>{{item.cart_list.selling_count}}</p>
                      <button v-on:click="change_selling_count(index, +1)"></button>
                    </div>
                  </div>
                  <div class="pageCartlist_dataTotalPrice">
                    <p>합계</p>
                    <p v-if="item.cart_list.sellingDiscountPrice === 0">{{String(item.cart_list.sellingPrice * item.cart_list.selling_count).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}원</p>
                    <p v-else>{{String(item.cart_list.sellingDiscountPrice * item.cart_list.selling_count).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}원</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> <!-- 왼쪽리스트 -->

        <div> <!-- 오른쪽 리스트 -->
          <div class="mallMy_productListWrap mallMy_cL_totalPriceBody">
            <div class="mallMy_productListBox">
                <div
                  class="mallMy_productListBoxInner">
                  <div class="mallMy_cL_totalPrice"> <!-- pageCartlist_dateTotalPrice -->
                    <p>총 상품금액</p>
                    <p>{{String(statusData.totalsellingPrice).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}<span>원</span></p>
                  </div>

                  <div class="mallMy_cL_totalPriceBtn"> <!-- pageCartlist_dataWrapBtn -->
                    <button v-on:click="selected_order">선택상품주문</button>
                    <button v-on:click="all_order">전체상품주문</button>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="pageCartlist_noData"
        v-if="statusData.cartListData.length === 0">
        <p>장바구니가 비어 있습니다.</p>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import { ref } from 'vue'
import {
  get_session_customer,
  check_user_cart_list,
  update_recent_cart_list,
  update_cart_list,
  base_url_export
} from '../../ETC/Axios.vue'

export default {
  name: 'CartList',
  components: {
    Header: Header,
    Footer: Footer,
    Scroll: Scroll
  },
  setup () {
    return {
      statusData: ref({
        cartListData: [],
        viewStatus: true,
        baseUrlExport: base_url_export,
        sessionData: '',
        totalsellingPrice: 0,
        allCheckedStatus: false,
        allCheckedList: [],
        selectList: []
      })
    }
  },
  methods: {
    formatPrice (price) {
      return String(Math.floor(price)).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    all_check: function () {
      if (this.statusData.allCheckedStatus === true) {
        this.statusData.allCheckedStatus = false
        this.statusData.selectList = []
      } else {
        this.statusData.allCheckedStatus = true
        this.statusData.selectList = this.statusData.allCheckedList
      }
    },
    view_cart_list: function () {
      this.statusData.viewStatus = !this.statusData.viewStatus
    },
    change_cart_list: function (session_result, temp_cart_list) {
      if (JSON.parse(temp_cart_list).length !== 0) {
        const change_cart_list_array = []
        update_recent_cart_list(temp_cart_list).then(result_recent_cart_list => {
          this.statusData.cartListData = result_recent_cart_list
          this.statusData.totalsellingPrice = 0
          this.statusData.allCheckedList = []
          let check_box_index = 0
          if (result_recent_cart_list !== '') {
            result_recent_cart_list.forEach((element) => {
              change_cart_list_array.push(element.cart_list)
              this.statusData.allCheckedList.push(check_box_index)
              if (element.cart_list.sellingDiscountPrice !== 0) {
                this.statusData.totalsellingPrice += element.cart_list.sellingDiscountPrice * element.cart_list.selling_count
              } else {
                this.statusData.totalsellingPrice += element.cart_list.sellingPrice * element.cart_list.selling_count
              }
              check_box_index++
            })
          }
          if (session_result === '') {
            localStorage.setItem('cart_list', JSON.stringify(change_cart_list_array))
          } else {
            update_cart_list(
              session_result.customer_ID,
              JSON.stringify(change_cart_list_array)
            )
          }
        })
      }
    },
    remove_selected_items: function () {
      this.statusData.cartListData = this.statusData.cartListData.filter((item, index) => {
        return !this.statusData.selectList.includes(Number(index))
      })
      const change_cart_list_array = this.statusData.cartListData.map(item => item.cart_list)

      if (this.statusData.sessionData === '') {
        localStorage.setItem('cart_list', JSON.stringify(change_cart_list_array))
      } else {
        update_cart_list(
          this.statusData.sessionData.customer_ID,
          JSON.stringify(change_cart_list_array)
        )
      }
      this.statusData.selectList = []
    },
    judgement_cart_list: function (session_result) {
      let temp_cart_list = []
      if (session_result === '') {
        if (localStorage.getItem('cart_list') !== null) {
          temp_cart_list = localStorage.getItem('cart_list')
          this.change_cart_list(session_result, temp_cart_list)
        }
      } else {
        check_user_cart_list(
          session_result.customer_ID
        ).then(result_cart_list => {
          if (result_cart_list.length !== 0) {
            temp_cart_list = result_cart_list[0].cart_list_array
            this.change_cart_list(session_result, temp_cart_list)
          }
        })
      }
    },
    change_selling_count: function (index, change_count_number) {
      if (this.statusData.cartListData[index].cart_list.selling_count + change_count_number <= 0) {
        alert('1개 이상부터 구매할 수 있는 상품입니다.')
      } else {
        this.statusData.cartListData[index].cart_list.selling_count = this.statusData.cartListData[index].cart_list.selling_count + change_count_number
        const change_cart_list = []
        this.statusData.cartListData.forEach((element) => {
          change_cart_list.push(element.cart_list)
        })
        this.change_cart_list(
          this.statusData.sessionData,
          JSON.stringify(change_cart_list)
        )
      }
    },
    selected_order: function () {
      if (this.statusData.selectList.length === 0) {
        alert('선택된 상품이 없습니다.')
        return
      }
      const selectedItems = this.statusData.selectList.map(index => this.statusData.cartListData[index])
      const route = this.statusData.sessionData === '' ? '/Login?buy_status=1' : '/Order'
      const orderList = selectedItems.map(item => ({
        product_ID_use_selling: item.cart_list.product_ID_use_selling,
        sellingPrice: item.cart_list.sellingPrice,
        sellingDiscountPrice: item.cart_list.sellingDiscountPrice,
        productOptionListSelectArray: item.cart_list.productOptionListSelectArray,
        selling_count: item.cart_list.selling_count,
        product_note_title: item.cart_list.product_note_title,
        product_note: item.cart_list.product_note,
        product_group_option_title: item.cart_list.product_group_option_title,
        product_group_option_name: item.cart_list.product_group_option_name
      }))

      localStorage.setItem('buy_list', JSON.stringify(orderList))
      this.$router.push({ path: route })
    },
    all_order: function () {
      if (this.statusData.cartListData.length === 0) {
        alert('장바구니에 상품이 없습니다.')
        return
      }
      const route = this.statusData.sessionData === '' ? '/Login?buy_status=1' : '/Order'
      const orderList = this.statusData.cartListData.map(item => ({
        product_ID_use_selling: item.cart_list.product_ID_use_selling,
        sellingPrice: item.cart_list.sellingPrice,
        sellingDiscountPrice: item.cart_list.sellingDiscountPrice,
        productOptionListSelectArray: item.cart_list.productOptionListSelectArray,
        selling_count: item.cart_list.selling_count,
        product_note_title: item.cart_list.product_note_title,
        product_note: item.cart_list.product_note,
        product_group_option_title: item.cart_list.product_group_option_title,
        product_group_option_name: item.cart_list.product_group_option_name
      }))
      localStorage.setItem('buy_list', JSON.stringify(orderList))
      this.$router.push({ path: route })
    }
  },
  mounted () {
    get_session_customer().then(result => {
      this.statusData.sessionData = result
      this.judgement_cart_list(result)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/CartList/CartList.vue